import { TaskImportance } from 'owa-todo-types';

export default function isImportant(importance: TaskImportance): boolean {
    return importance === TaskImportance.High;
}
